import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import clsx from 'clsx'

const DisabledLink = ({ to, disabled, className, children, ...props }) => {
    const handleClick = event => {
        if (disabled) {
            event.preventDefault()
        }
    }

    return (
        <Link
            to={disabled ? '#' : to}
            onClick={handleClick}
            className={clsx(className, {
                'cursor-not-allowed': disabled,
            })}
            style={{
                filter: disabled ? 'brightness(0.6)' : 'none',
            }}
            {...props}
        >
            {children}
        </Link>
    )
}

DisabledLink.propTypes = {
    to: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
}

export default DisabledLink
